import { render, staticRenderFns } from "./header.vue?vue&type=template&id=67955d10"
import script from "./header.vue?vue&type=script&lang=js"
export * from "./header.vue?vue&type=script&lang=js"
import style0 from "./header.vue?vue&type=style&index=0&id=67955d10&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ProductNavigationItems: require('/app/components/product/navigationItems.vue').default,Search: require('/app/components/search.vue').default,Header: require('/app/components/header.vue').default})
